import { Search } from 'lucide-react';
import { useEntrance } from '../context/entrance-context';
import {
  ALL_CATEGORIES,
  ENTRANCE_CATEGORY_COLORS,
  ENTRANCE_CATEGORY_LABELS,
} from '../data/entrance-types';

export function EntranceFilterBar() {
  const { state, toggleCategory, toggleHideDone, setSearch } = useEntrance();

  return (
    <div className="flex flex-wrap items-center gap-2">
      {/* Search */}
      <div className="relative">
        <Search size={14} className="absolute left-2 top-1/2 -translate-y-1/2 text-gray-500" />
        <input
          type="text"
          className="bg-gray-800 text-white text-xs pl-7 pr-2 py-1.5 rounded border border-gray-700 outline-none focus:border-zelda-gold w-40"
          placeholder="Search..."
          value={state.searchTerm}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {/* Category toggles */}
      <div className="flex flex-wrap gap-1">
        {ALL_CATEGORIES.map((cat) => {
          const isActive = state.visibleCategories.includes(cat);
          const color = ENTRANCE_CATEGORY_COLORS[cat];
          return (
            <button
              key={cat}
              onClick={() => toggleCategory(cat)}
              className={`
                px-2 py-1 rounded text-[10px] font-medium border transition-all
                ${isActive
                  ? 'text-white'
                  : 'text-gray-500 border-gray-700 opacity-40'
                }
              `}
              style={
                isActive
                  ? { borderColor: color, backgroundColor: `${color}25`, color: '#fff' }
                  : undefined
              }
            >
              {ENTRANCE_CATEGORY_LABELS[cat]}
            </button>
          );
        })}

        {/* Hide done toggle */}
        <button
          onClick={toggleHideDone}
          className={`
            px-2 py-1 rounded text-[10px] font-medium border transition-all
            ${state.hideDone
              ? 'text-white border-red-500 bg-red-500/15'
              : 'text-gray-500 border-gray-700 opacity-40'
            }
          `}
        >
          Hide Done
        </button>
      </div>
    </div>
  );
}
